import { useContext } from 'react'

import { EmailDraft } from '../../../../context'

export function useEmailDraft(context = EmailDraft) {
  return useContext(context)
}
